import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import PortableTextFull from "../components/PortableTextFull"

const Cookies = ({ data }) => {
  return (
    <Layout>
      <Seo title={data.sanityCookies.title || `Cookies`} />
      <div className="max-w-screen-xl mx-auto">
        <div className="p-5">
          <PortableTextFull textData={data.sanityCookies._rawBody} />
          <small className="font-roboto font-semibold">
            Дата обновления: {data.sanityCookies._updatedAt}
          </small>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    sanityCookies {
      title
      _rawBody(resolveReferences: { maxDepth: 10 })
      _updatedAt(formatString: "DD-MM-YYYY")
    }
  }
`
export default Cookies
